import { Media } from 'media'
import { ComponentType } from 'react'
import { AgentDesktop } from './agent-desktop'
import { AgentMobile } from './agent-mobile'

interface Props {
  property: any
  agent: any
  beforeOnShareClick: () => Promise<void>
  shareUrl: string
}

export const Agent: ComponentType<Props> = ({ property, agent, beforeOnShareClick, shareUrl }) => (
  <>
    <Media at="xs">
      <AgentMobile name={property.name} agent={agent} uuid={property.uuid} principalNotes={property.principalNotes} beforeOnShareClick={beforeOnShareClick} shareUrl={shareUrl} />
    </Media>
    <Media greaterThan="xs">
      <AgentDesktop name={property.name} agent={agent} uuid={property.uuid} principalNotes={property.principalNotes} beforeOnShareClick={beforeOnShareClick} shareUrl={shareUrl} />
    </Media>
  </>
)
